<template>
<div ref="NESTEdit">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑窝次</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="Nestlist.length > 1 ? Nestlist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回日宠物繁育</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in Nestlist" :key="index" :ref="'Nest'+index">
            <div class="TTL-form-submit-box-title">窝次-{{index+1}}</div>
            <el-form :inline="false">
                
                <el-form-item>
                    <label class="TTL-form-label">窝次信息</label>
                    <div class="TTL-birth-main top20">
                        <div class="TTL-birth">
                            <div class="TTL-birth-info" @click="SelectPetInfos(index,2,item.girl_type)">
                                <div class="TTL-pet-image">
                                <el-image :src="item.boy_pet_thumb ? item.boy_pet_thumb : require('@/assets/icon/pet-upload-default.png')" fit="cover" class="TTL-image-box-middle"/>
                                </div>
                                <span class="TTL-birth-name">{{item.boy_pet_name ? item.boy_pet_name : '宠物粑粑'}}<h>{{item.boy_type_name ? '（'+item.boy_type_name+'）' : ''}}</h></span>  
                                <div class="manorwoman" @click.stop="closePet(index,2)" v-if="item.boy_pet_id > 0">
                                <el-image :src="require('@/assets/icon/close-blue.png')" />
                                </div>
                            </div>
                        </div>
                        <div class="TTL-birth compare"><div class="TTL-pet-image"><el-image :src="require('@/assets/icon/compare.png')" fit="cover"/></div></div>
                        <div class="TTL-birth">
                            <div class="TTL-birth-info" @click="SelectPetInfos(index,3,item.boy_type)">
                                <div class="TTL-pet-image">
                                <el-image :src="item.girl_pet_thumb ? item.girl_pet_thumb : require('@/assets/icon/pet-upload-default.png')" fit="cover" class="TTL-image-box-middle"/>
                                </div>
                                <span class="TTL-birth-name">{{item.girl_pet_name ? item.girl_pet_name : '宠物麻麻'}}<h>{{item.girl_type_name ? '（'+item.girl_type_name+'）' : ''}}</h></span>  
                                <div class="manorwoman" @click.stop="closePet(index,3)" v-if="item.girl_pet_id > 0">
                                <el-image :src="require('@/assets/icon/close-blue.png')" />
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">配种日</label>
                    <div class="TTL-datetime">
                    <el-date-picker v-model="item.loveday" type="date" value-format="YYYY-MM-DD" placeholder="请选择配种日期" @change="SaveDataToBrowser"/>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">生产日</label>
                    <div class="TTL-datetime">
                    <el-date-picker v-model="item.expireday" type="date" value-format="YYYY-MM-DD" placeholder="请选择配种日期" @change="SaveDataToBrowser"/>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div class="TTL-button"><el-button @click="AddBirthPet(index)">添加繁育宠物</el-button></div>
                </el-form-item>
                <el-form-item>
                <div class="TTL-table" style="margin-top:30px;" :ref="'Npet'+index">
                <el-table :data="item.pets" stripe="true" empty-text="">
                    <el-table-column label="繁育宠物" align="center">
                        <template #default="tcope">
                            <div class="TTL-pet-image">
                                <el-image :src="tcope.row.thumb ? tcope.row.thumb : require('@/assets/icon/pet-upload-default.png')" fit="cover" class="TTL-image-box-small"/>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="宠物名称" prop="tcope.row.name" align="center" />
                    <el-table-column label="性别" align="center">
                        <template #default="tcope">{{tcope.row.sex==1 ? '哥哥' : '妹妹'}}</template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template #default="tcope">
                        <div class="TTL-button">
                            <el-button type="del" @click="delpet(index,tcope.$index)">删除</el-button>
                        </div>
                        </template>
                    </el-table-column>
                </el-table>
                </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_BIRTH from '@/Interface/Pets/Birth';
import INTERFACE_MODEL_NEST from '@/Interface/Pets/Petnest';
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
    components:{},
    data() {
        return {
            type:'add',
            file:'',             //图片变量，占位符
            addlimit: 10,        //单次新增限制
            Nestlist:[       //日程信息列表
                {
                 boy_pet_id:'',boy_pet_name:'',boy_pet_thumb:'',boy_sex:'',boy_type:'',boy_type_name:'',
                 girl_pet_id:'',girl_pet_name:'',girl_pet_thumb:'',girl_sex:'',girl_type:'',girl_type_name:'',
                 loveday:'',expireday:'',pets:[]
                }
            ],    

            petselectIndex:'', //繁育宠物选择序号
            petselectsex:1,    //选择宠物性别（1-公 2-母）
            ismorepet:false,   //是否选择更多宠物信息
            pointref:'',

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.ParseDataFromBrowser(); //解析之前填写的数据
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {

            //选择宠物完成后返回宠物信息组件
            if(data.pets && this.ismorepet) {
                var obj=this.Nestlist[this.petselectIndex];
                var child=obj.pets;
                var isexit=false;
                for(var i in child) if(child[i].id==data.pets.id) isexit=true;
                if(isexit) return false;

                child.push({id:data.pets.id,name:data.pets.name,thumb:data.pets.thumb,sex:data.pets.sex});
                this.SaveDataToBrowser(); //保存数据
                //定位锚点
                this.$refs[this.pointref][0].scrollIntoView({behavior:'smooth',block:'start'}); 
                return false;

            }else if(data.pets && this.petselectsex==2) { //公信息
                var obj=this.Nestlist[this.petselectIndex];
                obj.boy_pet_id=data.pets.id;
                obj.boy_pet_name=data.pets.name;
                obj.boy_pet_thumb=data.pets.thumb;
                obj.boy_sex=data.pets.sex;
                obj.boy_type=data.pets.type;
                obj.boy_type_name=data.pets.pettype;
                this.SaveDataToBrowser(); //保存数据
                //定位锚点
                this.$refs[this.pointref][0].scrollIntoView({behavior:'smooth',block:'start'}); 
                return false;

            }else if(data.pets && this.petselectsex==3) { //母信息
                var obj=this.Nestlist[this.petselectIndex];
                obj.girl_pet_id=data.pets.id;
                obj.girl_pet_name=data.pets.name;
                obj.girl_pet_thumb=data.pets.thumb;
                obj.girl_sex=data.pets.sex;
                obj.girl_type=data.pets.type;
                obj.girl_type_name=data.pets.pettype;
                this.SaveDataToBrowser(); //保存数据
                //定位锚点
                this.$refs[this.pointref][0].scrollIntoView({behavior:'smooth',block:'start'}); 
                return false;

            }


            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm('当前有数据正在执行编辑操作，是否要执行覆盖操作 ？','操作提示',{confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}).then(()=> {
                    this.GetPetNestInfos(data.ids);
                }).catch(()=> {
                    
                });

            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                this.GetPetNestInfos(data.ids);
            }

        },


        /** 提交数据 **/
        submitData() {
            var checkresult=this.CheckDataBeforeSubmit();
            if(checkresult.error==1) {this.$notice({title:'提交数据提示',message:checkresult.message,type:'warning'});return false;}

            //调整提交数据
            var data=[];
            for(var i=0;i<this.Nestlist.length;i++) data.push(this.Nestlist[i]);
            data=JSON.stringify(data);
            var loadingobj=this.$refs.NESTEdit;
            this.$loading.openloading(loadingobj);  //加载等待动画

            INTERFACE_MODEL_NEST.EDIT_NEST({data:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.resetParam(); //重置当前数据
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            });
        },


        /** 数据提交前进行检测 **/
        CheckDataBeforeSubmit() {
            var result={error:0,message:''};
            if(this.Nestlist.length==0) {result={error:1,message:'请添加窝次信息'};return result;}
            return result;
        },


        /** 选择宠物信息 **/
        SelectPetInfos(index,sex,type) {
            this.petselectIndex=index;   //设置
            this.petselectsex=sex;       //设置选择性别
            this.ismorepet=false;        //是否选择更多宠物
            this.pointref='Nest'+index; //设置锚点
            var navinfo={name:'宠物信息管理',labelentry:'Pet',components:'Pet',isshow:false};
            var data={Method:''};

            //需要组件执行设置的参数
            data.paramsetting={sex:sex,type:type,p:1,rollpage:10,ischange:true};
            //需要组件执行锁定的搜索项
            data.paramlock={sexlock:true,typelock:true};

            data.isselect=true;
            data.rollbackcomponent='EditPetNest';
            data.rollbackname='编辑窝次';
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 取消已选择的宠物 **/
        closePet(index,sex) {

            var obj=this.Nestlist[index];
            if(sex==2) { //种公
                obj.boy_pet_id='';
                obj.boy_pet_name='';
                obj.boy_pet_thumb='';
                obj.boy_sex='';
                obj.boy_type='';
                obj.boy_type_name='';

            }else if(sex==3) { //种母
                obj.girl_pet_id='';
                obj.girl_pet_name='';
                obj.girl_pet_thumb='';
                obj.girl_sex='';
                obj.girl_type='';
                obj.girl_type_name='';

            }
        },


        /** 新增繁育宠物信息 **/
        AddBirthPet(index) {
            this.petselectIndex=index;   //设置
            this.ismorepet=true;         //是否选择更多宠物
            this.pointref='Npet'+index;   //设置锚点
            var navinfo={name:'宠物信息管理',labelentry:'Pet',components:'Pet',isshow:false};
            var data={Method:''};

            //需要组件执行设置的参数
            data.paramsetting={p:1,rollpage:10,ischange:true};
            data.isselect=true;
            data.rollbackcomponent='EditPetNest';
            data.rollbackname='编辑窝次';
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 删除宠物 **/
        delpet(index,sindex) {
            this.Nestlist[index].pets.splice(sindex,1);
        },


        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载  

        /** 获取窝次信息列表 **/
        GetPetNestInfos(ids) {
            var loadingobj=this.$refs.NESTEdit;
            this.$loading.openloading(loadingobj);  //加载等待动画
            INTERFACE_MODEL_NEST.GET_NEST_INFOS({ids:ids}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.Nestlist=res.data;
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            });
        },


        /** 重置加载数据 **/
        resetParam() {
            var data={
                  boy_pet_id:'',boy_pet_name:'',boy_pet_thumb:'',boy_sex:'',boy_type:'',boy_type_name:'',
                  girl_pet_id:'',girl_pet_name:'',girl_pet_thumb:'',girl_sex:'',girl_type:'',girl_type_name:'',
                  loveday:'',expireday:'',pets:[]
                };
            this.Nestlist=[data];
        },



        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.Nestlist);
            localStorage.setItem('addNestdata',data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem('addNestdata');
            data ? data : data=[];
            
            !data || data=='' || data==[] ? 
            this.Nestlist=[{
                 boy_pet_id:'',boy_pet_name:'',boy_pet_thumb:'',boy_sex:'',boy_type:'',boy_type_name:'',
                 girl_pet_id:'',girl_pet_name:'',girl_pet_thumb:'',girl_sex:'',girl_type:'',girl_type_name:'',
                 loveday:'',expireday:'',pets:[]
            }] : 
            this.Nestlist=JSON.parse(data);
        },

        /** 返回宠物窝次组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'窝次管理',labelentry:'PetNest',components:'PetNest',isshow:false};
            var data={Method:''};
            if(isdellocal) data.delcomponents='EditPetNest';
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-remind-image {display:inline-block;width:70px;height: 70px;margin-left:20px;border-radius: 50%;}
.TTL-remind-image .el-image {border-radius: 50%;}
.TTL-birth-main {display:inline-flex;align-items: center;width:100%}
.TTL-birth {display:inline-block;}
.TTL-birth-info {width:120px;text-align: center;position:relative;}
.TTL-birth-info .TTL-image-box-middle {border-radius: 50%;}
.TTL-birth-name {font-size:13px;text-align: center;width:100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.compare {width:30px;height: 30px;margin:-40px 20px 0 20px;}
.TTL-birth-title {font-size:13px;color:#9c7d20;}
.manorwoman {width:20px;height: 20px;border-radius: 50%;position:absolute;top:0;right:0;background-color: #ffffff;padding:5px;cursor:pointer;}
</style>